import { Pipe, PipeTransform } from '@angular/core';

import { LabelsEnum } from '@shared/sms/enums';

@Pipe({ name: 'notificationLabel', standalone: false })
export class NotificationLabelPipe implements PipeTransform {
  transform(value: LabelsEnum): any {
    if (value === LabelsEnum.resconf) {
      return 'confirmation';
    }

    if (value === LabelsEnum.rescheckin) {
      return 'check-in';
    }

    if (value === LabelsEnum.toGoOrderReady) {
      return 'to-go ready';
    }

    if (value === LabelsEnum.toGoOrderConfirmation) {
      return 'to-go confirmation';
    }

    if (value === LabelsEnum.waitlistCancellation) {
      return 'cancellation';
    }

    return value;
  }
}
